module.exports = __webpack_public_path__ + "6a72a3b5bf521e9e11e90d208ba72572.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bg2.jpg
 ** module id = 738
 ** module chunks = 0
 **/